import React from 'react';
import {Grid} from "@mui/material";
import SortFilter from "../../SortFilter/SortFilter";
import useAllLocationNames from "../../../hooks/components/location/useAllLocationNames";
import {useSnackbar} from "../../../context/snackbar-context";

const SpaceUsageFilterForm = (props) => {
  const {filterByOptions = [], onChange = () => {}, defaultStartDate, defaultEndDate} = props;
  const { snackbarShowMessage } = useSnackbar();

  const locations = useAllLocationNames(snackbarShowMessage);

  const sortByOptions = [
    {value: 'CALENDAR_DATE', label: 'Date'},
    {value: 'TOTAL_SPACES_BOOKED', label: 'Booked Spaces'},
    {value: 'MAX_INVENTORY_COUNT', label: 'Max Inventory'},
    {value: 'OVERAGE_SPACES_CHARGED_COUNT', label: 'Charged Overages'},
    {value: 'BUYER_COMPANY_NAME', label: 'Buyer'},
    {value: 'LOCATION_NAME', label: 'Location'},
    {value: 'BOOKING_NUMBERS', label: 'Bookings'},
    {value: 'OVERAGE_INVOICE_NUMBERS', label: 'Overage Invoices'},
  ];

  return (
    <Grid mb={2} item container direction='column' component={'section'}>
    <SortFilter
      filterCallback={onChange}
      sortByOption={sortByOptions}
      locations={locations}
      filterByOption={filterByOptions}
      defaultStartDate={defaultStartDate}
      defaultEndDate={defaultEndDate}
      defaultSortBy={'CALENDAR_DATE'}
      sortDir={'asc'}
    />
    </Grid>
  );
};

export default SpaceUsageFilterForm;
